export default __webpack_public_path__ + "static/form-multiple-action-buttons-dont-ee4656b4ef55016b8f8ff9f1e9e90a3f.png";